import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiSunrunHomepageLead' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    leadSection: {
      display: 'flex',
      backgroundColor: 'transparent',
      padding: typography.pxToRem(100),
      justifyContent: 'center',
      alignItems: 'center',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
        flexDirection: 'column',
      },
    },
    leadTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'left',
      marginRight: typography.pxToRem(100),
      maxWidth: typography.pxToRem(575),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginTop: 0,
        marginRight: typography.pxToRem(0),
        paddingLeft: typography.pxToRem(40),
        paddingRight: typography.pxToRem(40),
        paddingTop: typography.pxToRem(75),
        paddingBottom: typography.pxToRem(63),
        textAlign: 'left',
        alignItems: 'flex-start',
      },
    },
    leadFormContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    leadTitle: {
      ...type['64_medium'],
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
        marginBottom: typography.pxToRem(15),
      },
    },
    subtitle: {
      ...type['28_medium'],
      marginTop: typography.pxToRem(18),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
        marginTop: typography.pxToRem(14),
        fontWeight: 500,
        fontSize: typography.pxToRem(16),
        lineHeight: typography.pxToRem(24),
        letterSpacing: '-0.02rem',
      },
    },
    subtitleImage: {
      width: '90%',
    },
    leadSubtitleContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: typography.pxToRem(40),
    },
    leadSubtitle: {
      ...type['20_regular'],
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontWeight: 500,
        fontSize: typography.pxToRem(16),
        lineHeight: typography.pxToRem(24),
        letterSpacing: '-0.02rem',
        marginBottom: typography.pxToRem(50),
      },
    },
    listContainer: {
      width: '100%',
      marginTop: typography.pxToRem(50),
    },
    listItem: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginTop: typography.pxToRem(16),
      height: '100%',
    },
    listElement: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...type['28_medium'],
      backgroundColor: brandColors.primaryMain,
      color: brandColors.white,
      height: typography.pxToRem(60),
      width: typography.pxToRem(60),
      minWidth: typography.pxToRem(60),
      borderRadius: typography.pxToRem(30),
      marginRight: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        textAlign: 'center',
        borderRadius: '50%',
        width: typography.pxToRem(36),
        height: typography.pxToRem(36),
        padding: typography.pxToRem(29),
      },
    },
    listTitle: {
      ...type['24_medium'],
    },
  })
);

export default useStyles;
